import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "@/components/ui/dialog";
import ConnectForm from "@/components/site/ConnectForm";

const WhatsIcon = ({ className = "w-5 h-5" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M19.05 4.91A9.83 9.83 0 0 0 12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.74.46 3.45 1.32 4.95L2 22l5.25-1.38a9.86 9.86 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.91-7.02Z" />
    </svg>
);

export default function ConnectModal({ open, onOpenChange, prefill = {} }) {
    // Force remount of form when prefill or open changes so fields reset cleanly.
    const [key, setKey] = useState(0);
    useEffect(() => {
        if (open) setKey((k) => k + 1);
    }, [open]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                className="sm:max-w-[460px] p-0 overflow-hidden rounded-3xl border-0"
                data-testid="connect-modal"
            >
                <div className="bg-white p-7 sm:p-8">
                    <DialogHeader>
                        <div className="flex items-center gap-3">
                            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#25D366] text-white">
                                <WhatsIcon className="h-6 w-6" />
                            </span>
                            <div>
                                <DialogTitle className="font-display text-xl font-extrabold text-left">
                                    Connect With Our Specialist
                                </DialogTitle>
                                <DialogDescription className="text-sm text-black/60 text-left mt-1">
                                    Fill in your details and we&apos;ll connect you instantly on WhatsApp.
                                </DialogDescription>
                            </div>
                        </div>
                    </DialogHeader>
                    <ConnectForm
                        key={key}
                        variant="modal"
                        prefill={prefill}
                        showHeader={false}
                        testIdPrefix="connect"
                        onSubmitted={() => onOpenChange(false)}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
}
